export type SendEmailVisualProps = {
  width?: number;
};

export function SendEmailVisual({ width }: SendEmailVisualProps): JSX.Element {
  const w = width || 33;
  const h = width || 33;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2226 10.0962H4.97434C4.05015 10.0962 3.30095 10.8454 3.30095 11.7696V27.4876C3.30095 28.4118 4.05015 29.161 4.97434 29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962Z"
        fill="url(#paint0_linear_132_171)"
      />
      <path
        d="M28.2226 10.0962H4.97434C4.05015 10.0962 3.30095 10.8454 3.30095 11.7696V27.4876C3.30095 28.4118 4.05015 29.161 4.97434 29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962Z"
        fill="url(#paint1_linear_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H4.97434C4.05016 29.161 3.30095 28.4118 3.30095 27.4876V11.7696C3.30095 10.8454 4.05016 10.0962 4.97434 10.0962H16.5985Z"
        fill="url(#paint2_linear_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H4.97434C4.05016 29.161 3.30095 28.4118 3.30095 27.4876V11.7696C3.30095 10.8454 4.05016 10.0962 4.97434 10.0962H16.5985Z"
        fill="url(#paint3_radial_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H16.5985Z"
        fill="url(#paint4_linear_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H16.5985Z"
        fill="url(#paint5_linear_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H16.5985Z"
        fill="url(#paint6_linear_132_171)"
      />
      <path
        d="M16.5985 10.0962V29.161H28.2226C29.1468 29.161 29.896 28.4118 29.896 27.4876V11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H16.5985Z"
        fill="url(#paint7_linear_132_171)"
      />
      <path
        d="M3.30095 27.4877C3.30095 27.2367 3.43023 27.0035 3.64305 26.8705L16.388 18.904C16.5121 18.8264 16.6698 18.8264 16.7938 18.9043L29.5813 26.9191C29.7771 27.0417 29.896 27.2566 29.896 27.4877C29.896 28.4119 29.1468 29.1611 28.2226 29.1611H4.97434C4.05016 29.1611 3.30095 28.4119 3.30095 27.4877Z"
        fill="url(#paint8_linear_132_171)"
      />
      <path
        d="M3.30095 27.4877C3.30095 27.2367 3.43023 27.0035 3.64305 26.8705L16.388 18.904C16.5121 18.8264 16.6698 18.8264 16.7938 18.9043L29.5813 26.9191C29.7771 27.0417 29.896 27.2566 29.896 27.4877C29.896 28.4119 29.1468 29.1611 28.2226 29.1611H4.97434C4.05016 29.1611 3.30095 28.4119 3.30095 27.4877Z"
        fill="url(#paint9_linear_132_171)"
      />
      <path
        d="M3.30095 27.4877C3.30095 27.2367 3.43023 27.0035 3.64305 26.8705L16.388 18.904C16.5121 18.8264 16.6698 18.8264 16.7938 18.9043L29.5813 26.9191C29.7771 27.0417 29.896 27.2566 29.896 27.4877C29.896 28.4119 29.1468 29.1611 28.2226 29.1611H4.97434C4.05016 29.1611 3.30095 28.4119 3.30095 27.4877Z"
        fill="url(#paint10_linear_132_171)"
      />
      <path
        d="M3.30095 11.7696C3.30095 12.0205 3.43023 12.2538 3.64305 12.3869L16.388 20.3534C16.5121 20.4309 16.6698 20.4308 16.7938 20.3531L29.5813 12.3383C29.7771 12.2155 29.896 12.0007 29.896 11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H4.97434C4.05016 10.0962 3.30095 10.8454 3.30095 11.7696Z"
        fill="url(#paint11_linear_132_171)"
      />
      <path
        d="M3.30095 11.7696C3.30095 12.0205 3.43023 12.2538 3.64305 12.3869L16.388 20.3534C16.5121 20.4309 16.6698 20.4308 16.7938 20.3531L29.5813 12.3383C29.7771 12.2155 29.896 12.0007 29.896 11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H4.97434C4.05016 10.0962 3.30095 10.8454 3.30095 11.7696Z"
        fill="url(#paint12_linear_132_171)"
      />
      <path
        d="M3.30095 11.7696C3.30095 12.0205 3.43023 12.2538 3.64305 12.3869L16.388 20.3534C16.5121 20.4309 16.6698 20.4308 16.7938 20.3531L29.5813 12.3383C29.7771 12.2155 29.896 12.0007 29.896 11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H4.97434C4.05016 10.0962 3.30095 10.8454 3.30095 11.7696Z"
        fill="url(#paint13_linear_132_171)"
      />
      <path
        d="M3.30095 11.7696C3.30095 12.0205 3.43023 12.2538 3.64305 12.3869L16.388 20.3534C16.5121 20.4309 16.6698 20.4308 16.7938 20.3531L29.5813 12.3383C29.7771 12.2155 29.896 12.0007 29.896 11.7696C29.896 10.8454 29.1468 10.0962 28.2226 10.0962H4.97434C4.05016 10.0962 3.30095 10.8454 3.30095 11.7696Z"
        fill="url(#paint14_radial_132_171)"
      />
      <path
        d="M14.5574 3.40239C14.2141 3.40239 13.9359 3.68067 13.9359 4.02394V10.9957H12.7451C12.1267 10.9957 11.7982 11.7259 12.2085 12.1887L16.0677 16.5404C16.3533 16.8626 16.8564 16.8622 17.1415 16.5397L20.989 12.1878C21.3983 11.7249 21.0696 10.9957 20.4517 10.9957H19.2246V4.02394C19.2246 3.68067 18.9463 3.40239 18.603 3.40239H14.5574Z"
        fill="url(#paint15_linear_132_171)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_132_171"
          x1="5.2134"
          y1="20.7342"
          x2="29.8961"
          y2="20.555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFD0E6" />
          <stop offset="1" stopColor="#EEE5F8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_132_171"
          x1="3.30095"
          y1="20.6756"
          x2="6.20616"
          y2="20.6756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6BABD" />
          <stop offset="1" stopColor="#DCC9DD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_132_171"
          x1="11.6619"
          y1="22.4716"
          x2="10.9333"
          y2="21.3365"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.113759" stopColor="#DAC3DF" />
          <stop offset="1" stopColor="#DAC3DF" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_132_171"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.8918 17.1239) rotate(123.69) scale(2.60594 18.3017)"
        >
          <stop offset="0.342267" stopColor="#C8A6D7" />
          <stop offset="1" stopColor="#D1BBDD" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_132_171"
          x1="21.4692"
          y1="22.7662"
          x2="22.2636"
          y2="21.3365"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.113759" stopColor="#F6EFFE" />
          <stop offset="1" stopColor="#F3EAFD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_132_171"
          x1="20.5728"
          y1="17.6563"
          x2="21.5887"
          y2="19.0309"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3CDF7" />
          <stop offset="1" stopColor="#E9D9F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_132_171"
          x1="30.0753"
          y1="23.0351"
          x2="26.5193"
          y2="23.0351"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F3FB" />
          <stop offset="1" stopColor="#F0E9F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_132_171"
          x1="30.0754"
          y1="23.0351"
          x2="28.9036"
          y2="23.0351"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.199295" stopColor="#EBE9ED" />
          <stop offset="1" stopColor="#EBE9ED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_132_171"
          x1="16.5985"
          y1="30.8345"
          x2="16.5985"
          y2="20.4953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDC5F1" />
          <stop offset="1" stopColor="#E6DAF1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_132_171"
          x1="8.45725"
          y1="23.5553"
          x2="8.8936"
          y2="24.2099"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0734082" stopColor="#DDC2C8" />
          <stop offset="1" stopColor="#DFCDDA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_132_171"
          x1="22.8912"
          y1="22.649"
          x2="22.617"
          y2="23.0768"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.139796" stopColor="#F8F3FD" />
          <stop offset="1" stopColor="#F1EAF9" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_132_171"
          x1="16.5985"
          y1="10.0962"
          x2="16.5985"
          y2="20.4115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9E4E9" />
          <stop offset="1" stopColor="#E7DCF0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_132_171"
          x1="10.6791"
          y1="16.6432"
          x2="14.1355"
          y2="10.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1D5E7" />
          <stop offset="1" stopColor="#E1D5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_132_171"
          x1="3.30095"
          y1="11.6619"
          x2="6.1045"
          y2="11.6619"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1C1BC" />
          <stop offset="1" stopColor="#E9D1CD" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint14_radial_132_171"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.5545 14.0001) rotate(-138.233) scale(5.86078 25.9691)"
        >
          <stop stopColor="#FBF9FE" />
          <stop offset="1" stopColor="#F0ECF1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint15_linear_132_171"
          x1="10.3265"
          y1="10.3656"
          x2="15.0236"
          y2="2.33115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#844AE3" />
          <stop offset="1" stopColor="#E14AE3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
